<template>
  <div>
    <div :class="$style.modalContext">
      {{ $t('vendorsPage.vendorCurrency.beneficiary') }}
    </div>
    <MCAVendorFieldset>
      <UiDropdown
        ref="vendorCurrencyInput"
        :external-label="$t('vendorsPage.vendorCurrency.paymentCurrency')"
        name="currencyCode"
        data-cy="payment-currency"
        :label="$t('common.selectCurrency')"
        :error-msg="$t('common.errors.mandatory')"
        :options="currencyDropdownOptions"
        :value="currency.currencyCode"
        size="small"
        required
        @input="setVendorProps"
      />
      <UiDropdown
        ref="vendorBeneficiaryCountryInput"
        :external-label="$t('vendorsPage.vendorCurrency.beneficiaryCountry')"
        name="beneficiaryCountry"
        data-cy="beneficiary-country"
        :label="$t('common.selectCountry')"
        :error-msg="$t('common.errors.mandatory')"
        :options="countryOptions"
        :value="currency.beneficiaryCountry"
        size="small"
        required
        @input="setVendorProps"
      />
      <UiDropdown
        ref="vendorBankCountryInput"
        :external-label="$t('common.bankInfo.bankCountry')"
        name="bankCountry"
        data-cy="bank-country"
        :label="$t('common.selectCountry')"
        :error-msg="$t('common.errors.mandatory')"
        :options="countryOptions"
        :value="currency.bankCountry"
        size="small"
        required
        @input="setVendorProps"
      />
    </MCAVendorFieldset>
    <UiButton :text="$t('common.buttons.back')" @click="handlePrev" />
    <UiButton
      :text="
        getRequiredVendorFieldsRequest.isPending
          ? $t('common.buttons.loading')
          : $t('common.buttons.next')
      "
      data-cy="next-button"
      :disabled="getRequiredVendorFieldsRequest.isPending"
      @click="handleNext"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { mapRequestStatuses } from '@/utils/vuex-api-utils';
import { UiDropdown, UiButton } from 'ui-components';
import { SUPPORTED_CURRENCIES } from '@/data/currency-code-with-names';
import { COUNTRY_OPTIONS } from '@/data/country-code-with-names';
import MCAVendorFieldset from './MCAVendorFieldset.vue';
export default {
  components: {
    UiButton,
    UiDropdown,
    MCAVendorFieldset,
  },
  data() {
    return {
      currency: {},
    };
  },
  mounted() {
    this.currency = {
      currencyCode: this.selectedVendor.currencyCode,
      beneficiaryCountry: this.selectedVendor.beneficiaryAddress.country,
      bankCountry: this.selectedVendor.bankAddress.country,
    };
  },
  computed: {
    ...mapGetters(['selectedVendor']),
    ...mapRequestStatuses({
      getRequiredVendorFieldsRequest: 'GET_REQUIRED_VENDOR_FIELDS',
    }),
    countryOptions() {
      return COUNTRY_OPTIONS;
    },
    currencyDropdownOptions() {
      return Object.entries(SUPPORTED_CURRENCIES).map((currency, idx) => {
        return {
          key: idx,
          value: currency[0],
          name: currency[1],
        };
      });
    },
  },
  methods: {
    setVendorProps(val, name) {
      if (name) {
        this.currency[name] = val;
      }
    },
    async getRequiredFields() {
      const { currencyCode, beneficiaryCountry, bankCountry } = this.currency;
      if (!currencyCode || !beneficiaryCountry || !bankCountry) {
        return;
      }

      await this.$store.dispatchApiAction(
        'GET_REQUIRED_VENDOR_FIELDS',
        this.currency,
      );
      // const fieldPaths = {
      //   beneficiaryPostcode: 'beneficiaryAddress.postalCode',
      //   beneficiaryStateOrProvince: 'beneficiaryAddress.state',
      //   beneficiaryCity: 'beneficiaryAddress.city',
      //   cnaps: 'cnaps',
      //   bicSwift: 'swiftCode',
      //   aba: 'routingNumber',
      //   acctNumber: 'accountNumber',
      //   iban: 'iban',
      //   sortCode: 'sortCode',
      //   branchCode: 'branchCode',
      //   bsbCode: 'bsbCode',
      //   ifsc: 'ifsc',
      //   clabe: 'clabe',
      // };
      // console.log(
      //   'requiredVendorFieldsWithValidation',
      //   this.requiredVendorFieldsWithValidation,
      // );
      // const requiredFields = Object.keys(
      //   this.requiredVendorFieldsWithValidation,
      // );
      // const fieldsToErase = Object.keys(fieldPaths).filter(
      //   (field) => !requiredFields.includes(field),
      // );
      // const pathsToErase = [];
      // fieldsToErase.forEach((field) => {
      //   pathsToErase.push(fieldPaths[field]);
      //   // CurrencyCloud uses aba for both ACH & wire routing numbers
      //   // The two fields are coupled at the moment
      //   if (field === 'aba') pathsToErase.push('wireRoutingNumber');
      // });
      // pathsToErase.forEach((path) => {
      //   this.$store.dispatch('UPDATE_SELECTED_VENDOR', {
      //     path,
      //     val: null,
      //   });
      // });
    },
    async handleNext(event) {
      if (!event) return;

      const inputs = [
        this.$refs.vendorCurrencyInput,
        this.$refs.vendorBeneficiaryCountryInput,
        this.$refs.vendorBankCountryInput,
      ].filter((input) => input);

      inputs.forEach((field) => field.$touch());
      const isValid = inputs.every((field) => field.isValid);
      if (isValid) {
        const { currencyCode, beneficiaryCountry, bankCountry } = this.currency;
        const currencyData = {
          currencyCode,
          beneficiaryAddress: {
            country: beneficiaryCountry,
          },
          bankAddress: {
            country: bankCountry,
          },
        };
        await this.getRequiredFields();
        this.$emit('next-tab', currencyData);
      }
    },
    handlePrev(event) {
      if (event) {
        this.$emit('prev-tab');
      }
    },
  },
};
</script>
<style lang="less" module>
.modalContext {
  color: black;
  padding-bottom: 30px;
  text-align: center;
  font-weight: bold;
}
</style>
